export default "__VITE_ASSET__b7b36e7d__"